export default "__VITE_ASSET__BsfGdUbb__"